var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 90,
    height: 90,
    rx: 45,
    fill: "url(#paint0_linear_280_3553)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 38H39.5C39.1022 38 38.7206 38.158 38.4393 38.4393C38.158 38.7206 38 39.1022 38 39.5V48.5C38 48.8978 38.158 49.2794 38.4393 49.5607C38.7206 49.842 39.1022 50 39.5 50H48.5C48.8978 50 49.2794 49.842 49.5607 49.5607C49.842 49.2794 50 48.8978 50 48.5V39.5C50 39.1022 49.842 38.7206 49.5607 38.4393C49.2794 38.158 48.8978 38 48.5 38ZM47 47H41V41H47V47ZM63.5 47H60.5V41H63.5C63.8978 41 64.2794 40.842 64.5607 40.5607C64.842 40.2794 65 39.8978 65 39.5C65 39.1022 64.842 38.7206 64.5607 38.4393C64.2794 38.158 63.8978 38 63.5 38H60.5V30.5C60.5 29.7044 60.1839 28.9413 59.6213 28.3787C59.0587 27.8161 58.2957 27.5 57.5 27.5H50V24.5C50 24.1022 49.842 23.7206 49.5607 23.4393C49.2794 23.158 48.8978 23 48.5 23C48.1022 23 47.7206 23.158 47.4393 23.4393C47.158 23.7206 47 24.1022 47 24.5V27.5H41V24.5C41 24.1022 40.842 23.7206 40.5607 23.4393C40.2794 23.158 39.8978 23 39.5 23C39.1022 23 38.7206 23.158 38.4393 23.4393C38.158 23.7206 38 24.1022 38 24.5V27.5H30.5C29.7044 27.5 28.9413 27.8161 28.3787 28.3787C27.8161 28.9413 27.5 29.7044 27.5 30.5V38H24.5C24.1022 38 23.7206 38.158 23.4393 38.4393C23.158 38.7206 23 39.1022 23 39.5C23 39.8978 23.158 40.2794 23.4393 40.5607C23.7206 40.842 24.1022 41 24.5 41H27.5V47H24.5C24.1022 47 23.7206 47.158 23.4393 47.4393C23.158 47.7206 23 48.1022 23 48.5C23 48.8978 23.158 49.2794 23.4393 49.5607C23.7206 49.842 24.1022 50 24.5 50H27.5V57.5C27.5 58.2957 27.8161 59.0587 28.3787 59.6213C28.9413 60.1839 29.7044 60.5 30.5 60.5H38V63.5C38 63.8978 38.158 64.2794 38.4393 64.5607C38.7206 64.842 39.1022 65 39.5 65C39.8978 65 40.2794 64.842 40.5607 64.5607C40.842 64.2794 41 63.8978 41 63.5V60.5H47V63.5C47 63.8978 47.158 64.2794 47.4393 64.5607C47.7206 64.842 48.1022 65 48.5 65C48.8978 65 49.2794 64.842 49.5607 64.5607C49.842 64.2794 50 63.8978 50 63.5V60.5H57.5C58.2957 60.5 59.0587 60.1839 59.6213 59.6213C60.1839 59.0587 60.5 58.2957 60.5 57.5V50H63.5C63.8978 50 64.2794 49.842 64.5607 49.5607C64.842 49.2794 65 48.8978 65 48.5C65 48.1022 64.842 47.7206 64.5607 47.4393C64.2794 47.158 63.8978 47 63.5 47ZM57.5 57.5H30.5V30.5H57.5V48.4756C57.5 48.4756 57.5 48.4925 57.5 48.5C57.5 48.5075 57.5 48.5169 57.5 48.5244V57.5Z",
    fill: "#FFFADD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_280_3553",
    x1: 0,
    y1: 45.5,
    x2: 90,
    y2: 45.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#776D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463C01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD4);
export default __webpack_public_path__ + "static/media/d-4.c17bc3359835e17d1b43a96785529511.svg";
export { ForwardRef as ReactComponent };